export default {
    nameToSignature: function (name) {
        var signature = '';
        var nameArray = name.split(' ');
        if (nameArray.length > 1) {
            signature += nameArray[0][0];
            signature += nameArray[1];
        } else {
            signature = name;
        }
        return signature;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/SignatureService.js